import React, { Component } from 'react';

import bgImage from 'assets/images/heroes/lendaid-header-contact.jpg';

import PageBanner from 'components/Common/PageBanner';
import Intro from 'components/Pages/Advertise/Address';
import AdvertiseForm from 'components/Pages/Advertise/AdvertiseForm';

class Advertise extends Component {
  UNSAFE_componentWillMount() {
    window.scrollTo(0, 0);
  }

  render() {
    return (
      <div id='advertise'>
        {/* Page Banner */}
        <PageBanner smallHeading='ADVERTISING' largeHeading='Partner With Us' bgImage={bgImage} />

        <section className='padding-x padding-bottom margin-top'>
          <div className='single-column'>
            {/* Page Intro */}
            <Intro />

            {/* Page Form */}
            <AdvertiseForm />
          </div>
        </section>
      </div>
    );
  }
}

export default Advertise;
